// Studby — Stripe payment cancelled page.
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen grid place-items-center bg-background px-5">
      <div className="bg-card border border-border rounded-2xl p-8 max-w-sm w-full text-center" data-testid="payment-cancel-page">
        <XCircle size={44} className="text-muted-foreground mx-auto mb-4" aria-hidden="true" />
        <h1 className="font-heading text-xl font-bold mb-2">Checkout cancelled</h1>
        <p className="text-muted-foreground mb-6">No worries — you can subscribe whenever you're ready.</p>
        <Link to="/app/subscribe">
          <Button className="rounded-full w-full" data-testid="retry-subscribe-button">Back to plans</Button>
        </Link>
      </div>
    </div>
  );
}
